// extracted by mini-css-extract-plugin
export default {"Discount":"Discount_Discount__ahZnK","btn":"Discount_btn__inFuP","no":"Discount_no__xH018"};